import { fetchBooksByKeyword, fetchBookById, clearIdResults } from './store/searchBookSlice.js';
import { signIn, signUp, signOut, clearErrors, signInWithGoogle  } from './store/userSlice.js';
import { updateMemberProgress, createClub, setActiveClubId, fetchAllClubs, removePendingRequestClub, addPendingRequestClub, setCurrentBook, setDeadline, resetClubSlice, addMember } from './store/clubSlice.js';
import { addBookSuggestion, vote , setVotingDeadline, updateSuggestionBooks } from './store/suggestionsSlice.js';
import { addNote, removeNote } from './store/noteboardSlice.js';
import { addPendingRequestUser, removePendingRequestUser } from './store/userSlice';
import { current } from '@reduxjs/toolkit';
import { act } from 'react';


/*
 **********************************************************************************************
 *************------------------------- Header VIEW ------------------------------*************
 **********************************************************************************************
 */


export function mapStateToHeaderProps(state){
  const currentUser = state.user;
  
  return {
    currentUser: currentUser,
  }

}

export function mapDispatchToHeaderProps(dispatch){
  return {
    onLogout: () => {dispatch(signOut()),
                    dispatch(resetClubSlice())}

  }
  
}

/*
 **********************************************************************************************
 *************-------------------------- CLUB VIEW -------------------------------*************
 **********************************************************************************************
 */

export function mapStateToClubProps(state){  //chosen club
    // console.log(state.club.clubs[state.club.activeClubId])
    // console.log("mapStateToProps state:", state);
    // console.log("mapStateToProps activeClubId:", state.club.activeClubId);
    const activeClubId = state.club.activeClubId
    const currentClub = state.club.clubs[activeClubId] ?? null
    const currentUser = currentClub?.members?.find(member => member.userId === state.user.currentUser) ?? null
    const currentSuggestions = state.suggestions[activeClubId] ?? []
    const noteboard = state.noteboard[activeClubId] ?? []
    const searchResults = state.searchBook.searchResults ?? []
    const status = state.searchBook.status;
    const error = state.searchBook.error;
    const deadline = currentClub?.deadline ? new Date(currentClub.deadline) : null; 
   
    
    return {
        activeClubId: activeClubId,
        currentClub: currentClub,
        currentUser: currentUser,
        currentSuggestions: currentSuggestions,
        noteBoard: noteboard,
        searchResults: searchResults,
        searchResultId: state.searchBook.searchResultId,
        status: status,
        statusId: state.searchBook.statusId,
        error: error,
        errorId: state.searchBook.errorId,
        suggestions: state.suggestions,
        deadline: deadline,
    }
}
export function mapDispatchToClubProps(dispatch){
    //const clubId = state.club.activeClubId;
    return {
        onBackToMyClubs: (clubId) => dispatch(setActiveClubId({newClubId: null})),
        onAcceptRequest:(clubId, userId) => {dispatch(addMember({clubId, userId}))
      console.log("accepted request from: ", userId , " to club: ", clubId)},
        
        onRejectRequest: (clubId, userId) => dispatch(removePendingRequestClub({clubId, userId})),
        
        setProgress: (pages, userId) => dispatch(updateMemberProgress({pages, userId})),
        doSearch: (searchParams) => dispatch(fetchBooksByKeyword(searchParams)),
        searchBook: (searchParams) => dispatch(fetchBookById(searchParams)),
        addSuggestion: (book) => dispatch(addBookSuggestion(book)),
        cancelPopUp: () => dispatch(clearIdResults()),
        vote: (bookId, userId, score) => dispatch(vote({bookId, userId, score})),
        onChoosenBook: (book) => dispatch(setCurrentBook(book)),
        onStartVotingPeriod: (votingDeadline) => dispatch(setVotingDeadline({votingDeadline, isVotingActive: true})),
        onEndVotingPeriod: () => dispatch(setVotingDeadline({votingDeadline: "", isVotingActive: false})),
        onAddNote: 
          (clubId, userId, username, profileImg, message) => {
            const timestamp = Date.now();
            const noteId = `${userId}${timestamp}`
            // console.log(profileImg)
            dispatch(addNote({noteId, clubId, userId, username, profileImg, message, timestamp}))},
        
        onRemoveNote: (clubId, noteId) => dispatch(removeNote({clubId, noteId})),
        onSetDeadline: (deadline) => {
          // console.log("mapDispatch received:", deadline);
          dispatch(setDeadline({deadline}));},
        
    }
}

/*
 **********************************************************************************************
 *************-------------------------- MY CLUBS VIEW ---------------------------*************
 **********************************************************************************************
 */

export function mapStateToMyClubsProps(state){  //all clubs
  const userClubIds = Array.isArray(state.user.userClubs) ? state.user.userClubs : [];
  const clubsReady = userClubIds.length === 0 || userClubIds.every(id => state.club.clubs[id]?.clubReady === true);

  return {
    currentUser: state.user,
    clubs: state.club.clubs,
    clubsReady,
    pendingRequests: state.user.pendingRequests 
  }
}

export function mapDispatchToMyClubsProps(dispatch){
    
    // console.log("vi kommer till mapdispatch")
    return {
        onLogout: () => dispatch(signOut()),
        onCreateClub: (newClubName, newClubGenre) => dispatch(createClub({newClubName: newClubName, newClubGenre: newClubGenre})),
        onNavigateToClub: (clubId) => dispatch(setActiveClubId({newClubId: clubId})),
        onCancelJoinRequest: (clubId, userId) => 
      {dispatch(removePendingRequestClub({clubId, userId}))
      dispatch(removePendingRequestUser({clubId}))},
    }
}
/*
 **********************************************************************************************
 *************--------------------------- SIGN IN VIEW ---------------------------*************
 **********************************************************************************************
 */

// Extrahera data från Redux state
export function mapStateToSignInProps(state) {
  return {
    user: state.user,
    clubsReady: state.club.allClubsReady

  };
}

// Extrahera actions/dispatch
export function mapDispatchToSignInProps(dispatch) {
  return {
    signIn: (params) => dispatch(signIn(params)),
    signUp: (params) => dispatch(signUp(params)),
    clearErrors: () => dispatch(clearErrors()),
    signInWithGoogle: () => dispatch(signInWithGoogle()),
  };
}

/*
 **********************************************************************************************
 *************------------------------ FIND CLUBS VIEW --------------------------**************
 **********************************************************************************************
 */
export function mapDispatchToFindClubs(dispatch){
  
  return {
    onSendJoinRequest: (clubId, userId, username, profileImg) => 
      {dispatch(addPendingRequestClub({clubId, userId, username, profileImg}))
      dispatch(addPendingRequestUser({clubId}))},
    
    onCancelJoinRequest: (clubId, userId) => 
      {dispatch(removePendingRequestClub({clubId, userId}))
      dispatch(removePendingRequestUser({clubId}))},
    fetchAllClubs: (searchParams) => dispatch(fetchAllClubs(searchParams)),

    onNavigateToClub: (clubId) => dispatch(setActiveClubId({newClubId: clubId})),
    
  }
}

export function mapStateToFindClubs(state){
  const allClubs = state.club.searchResults
  return{
    allClubs : allClubs,
    user: state.user,
    searchResults: state.club.searchResults,
    status: state.club.status,
    error: state.club.error
  }

}
/*
 **********************************************************************************************
 *************------------------------PROFILE VIEW-------------------------------**************
 **********************************************************************************************
 */
 export function mapStateToMyProfile(state){
  
  return {
    user: state.user
  }
}